import { DeleteButton, Edit, SaveButton, SimpleForm } from "@/components/admin";
import { Card } from "@/components/ui/card";
import { UserCog } from "lucide-react";
import "../HR.css";
import {
  EmployeeBankInputs,
  EmployeeCoreInputs,
  EmployeeGovernmentInputs,
  EmployeePersonalInputs,
} from "./EmployeeInputs";

const EmployeeEditToolbar = () => (
  <div className="form-toolbar-premium">
    <DeleteButton className="btn-delete-action" />
    <SaveButton className="btn-green-action" label="Update Employee" />
  </div>
);

export const EmployeeEdit = () => (
  <Edit title="Edit Employee" actions={false}>
    <Card className="form-container">
      <div className="form-header-premium">
        <UserCog className="w-6 h-6 text-emerald-600" />
        <h2 className="text-2xl font-bold text-slate-900">Edit Employee Details</h2>
      </div>
      <SimpleForm toolbar={<EmployeeEditToolbar />}>
        <div className="space-y-8">
          <EmployeeCoreInputs />
          <EmployeePersonalInputs />
          <EmployeeGovernmentInputs />
          <EmployeeBankInputs />
        </div>
      </SimpleForm>
    </Card>
  </Edit>
);

